
import React, { useEffect, useState, useRef, } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    useCRUDController,
    Textarea,
    Card,
    Modal,
    Button,
    Typography,
    message,
    ProTableOt,
    useProTableOt,
    setParamsFilter,
    ExpandableText,
    DatePicker,
    ImageFileId
} from '../../ui/ot'
import { useTranslation } from "react-i18next";
import { Trash2, Plus, Check, TriangleAlert, Info } from "lucide-react";
import dayjs from 'dayjs';
import BookCoverManager from "../components/book_cover_manager";

const parseCoverImageDetails = (details) => {
    if (Array.isArray(details)) return details
    if (typeof details !== 'string') return []

    try {
        const parsed = JSON.parse(details)
        return Array.isArray(parsed) ? parsed : []
    }
    catch (error) {
        return []
    }
}

const getLatestCoverUploadTime = (details) => parseCoverImageDetails(details)
    .reduce((latest, detail) => {
        if (!detail?.upload_time) return latest
        const uploadTime = dayjs(detail.upload_time)
        if (!uploadTime.isValid()) return latest
        if (!latest || uploadTime.isAfter(latest)) return uploadTime
        return latest
    }, null)

const CoverUploadTime = ({ record, fileId }) => {
    if (!fileId) return null

    const latestUploadTime = getLatestCoverUploadTime([
        { upload_time: record?.bib_cover_latest_upload_time },
        ...parseCoverImageDetails(record?.bib_cover_images_detail),
    ])
    const formattedUploadTime = latestUploadTime?.format('YYYY-MM-DD HH:mm')

    return (
        <div
            className="mt-1 text-left text-xs leading-tight text-muted-foreground"
            title="書封上傳時間"
        >
            <div>上傳時間</div>
            <div className="whitespace-nowrap">{formattedUploadTime || '-'}</div>
        </div>
    )
}

const NewArrivalsListForm = ({
    propsForm,
    field,
    onFormFinish = () => { },
    keyPrefix = "library.backstage.new_arrivals_list_management",
    propsReloadCount,
    withdrawnOptions = []

}) => {

    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const axiosMode = Form.useWatch([field?.name ?? '', 'axiosMode'].join('.'), form)

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        let bibs_list_items_data = (values?.bibs_list_items_data || []).map((bibValue) => {
            return {
                ...bibValue,
                biblionumber: bibValue?.bib_biblionumber
            }
        })
        let temp = {
            ...values,
            bibs_list_items_data,
        }
        temp = setParamsFilter({ ...temp })

        onFormFinish({
            ...temp
        });

    };
    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        formValues = form.getFieldsValue();
    };


    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };

    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                axiosMode={axiosMode}
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={form.setFieldValue}
                                setCount={setCount}
                                keyPrefix={keyPrefix}
                                propsForm={form}
                                propsReloadCount={propsReloadCount}
                                withdrawnOptions={withdrawnOptions}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    propsForm,
    field,
    keyPrefix = "library.backstage.new_arrivals_list_management",
    propsReloadCount,
    withdrawnOptions = []
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef();
    const columns = [
        {
            title: t(`cover`),
            dataIndex: 'bibitem_isbn',
            key: 'bibitem_isbn',
            width: 140,

            render: (text, record, index) => {
                let fileId = record?.bib_cover_images || []
                let file_id = fileId.map((val) => {
                    return {
                        file_id: val
                    }
                })
                let bookImageData = []
                if (file_id.length > 0) {
                    bookImageData = [
                        ...file_id,
                    ]
                }
                else {
                    bookImageData = [
                        {
                            src: "https://media.taaze.tw/showLargeImageByIsbn.ashx?isbn=" + record?.bibitem_isbn
                        },
                    ]
                }

                return (
                    <Row justify="center">
                        <Col>
                            {
                                bookImageData.filter((e, index) => index === 0).map((value) => {
                                    if (value?.file_id) {
                                        return (
                                            <ImageFileId
                                                key={value?.file_id}
                                                file_id={value?.file_id}
                                                className="h-24 w-16 object-cover"
                                            />
                                        )
                                    }
                                    else {
                                        return (
                                            <img
                                                key={value?.src}
                                                src={"https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=" + record?.bibitem_isbn}
                                                alt={`${record?.bib_title} 封面`}
                                                className="h-24 w-16 object-cover" />
                                        )
                                    }
                                })
                            }
                            <CoverUploadTime
                                record={record}
                                fileId={bookImageData[0]?.file_id}
                            />
                            <div className="mt-1">
                                <BookCoverManager
                                    biblionumber={record?.bib_biblionumber}
                                    title={record?.bib_title}
                                    isbn={record?.bibitem_isbn}
                                    initialFileIds={fileId}
                                    buttonText="圖片"
                                    onChanged={({ images = [], fileIds = [] }) => {
                                        const oldData = propsForm.getFieldValue("bibs_list_items_data") || []
                                        const latestUploadTime = getLatestCoverUploadTime(images)
                                        const nextData = oldData.map((item, itemIndex) => itemIndex === index
                                            ? {
                                                ...item,
                                                bib_cover_images: fileIds,
                                                bib_cover_images_detail: images,
                                                bib_cover_latest_upload_time: latestUploadTime?.format('YYYY-MM-DD HH:mm') || null,
                                            }
                                            : item)
                                        propsForm.setFieldValue("bibs_list_items_data", nextData)
                                        reload()
                                    }}
                                />
                            </div>

                        </Col>
                    </Row>
                )


            }
        },
        {
            title: t(`title`),
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: 250,
            render: (text, record, index) => {
                return (<ExpandableText
                    text={`${record?.bib_title || ""}${record?.bib_subtitle || ""}`}

                    maxLines={3}>
                </ExpandableText>)
            }
        },
        {
            title: t(`author`),
            dataIndex: 'bib_author',
            key: 'bib_author',
        },
        {
            title: t(`publication_info`),
            dataIndex: 'bibitem_publishercode',
            key: 'bibitem_publishercode',
        },
        {
            title: t(`publication_date`),
            dataIndex: 'bib_copyrightdate',
            key: 'bib_copyrightdate',
        },
        {
            title: t(`actions`),
            dataIndex: 'operation',
            key: 'operation',
            sorter: false,
            disabled: true,
            render: (text, record, index) => {
                return (<Button
                    variant="ghost"
                    onClick={() => {
                        let oldData = propsForm.getFieldValue("bibs_list_items_data")
                        let data = oldData.filter((ele, ind) => ind !== index)
                        propsForm.setFieldValue("bibs_list_items_data", data)
                        reload()
                    }}
                >
                    <Trash2 className="h-4 w-4" />
                    {t('delete')}
                </Button>)
            }
        },


    ];
    const reload = () => {
        actionRef.current.reloadAndRest()
    }
    useEffect(() => {
        if (!!propsReloadCount) {
            reload()
        }

    }, [propsReloadCount])
    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Card title={t('list_information')} >
                        <Row gutter={[8, 8]}>
                            <Col span={24}>
                                <Row>
                                    <Form.Item
                                        hidden={true}
                                        {...field}
                                        name={[field?.name ?? '', 'list_id']}
                                        fieldKey={[field?.fieldKey ?? '', 'list_id']}
                                    >
                                        <div></div>
                                    </Form.Item>
                                    <Form.Item
                                        hidden={true}
                                        {...field}
                                        name={[field?.name ?? '', 'task_id']}
                                        fieldKey={[field?.fieldKey ?? '', 'task_id']}
                                        labelCol={24}
                                        wrapperCol={24}
                                    >
                                        <div></div>
                                    </Form.Item>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}  >
                                        <Form.Item
                                            {...field}
                                            name={[field?.name ?? '', 'task_name']}
                                            fieldKey={[field?.fieldKey ?? '', 'task_name']}
                                            label={t('display_title')}
                                            labelCol={24}
                                            wrapperCol={24}
                                        >
                                            <Input
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}  >
                                        <Form.Item
                                            {...field}
                                            name={[field?.name ?? '', 'start_time']}
                                            fieldKey={[field?.fieldKey ?? '', 'start_time']}
                                            label={t('start_date')}
                                            labelCol={24}
                                            wrapperCol={24}
                                        >
                                            <Input
                                                type="date"
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}  >
                                        <Form.Item
                                            {...field}
                                            name={[field?.name ?? '', 'end_time']}
                                            fieldKey={[field?.fieldKey ?? '', 'end_time']}
                                            label={t('end_date')}
                                            labelCol={24}
                                            wrapperCol={24}
                                        >
                                            <Input
                                                type="date"
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}  >
                                        <Form.Item
                                            {...field}
                                            name={[field?.name ?? '', 'task_explaination']}
                                            fieldKey={[field?.fieldKey ?? '', 'task_explaination']}
                                            label={t('display_description')}
                                            labelCol={24}
                                            wrapperCol={24}
                                        >
                                            <Textarea />
                                        </Form.Item>
                                    </Col>

                                </Row>
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col span={24}>
                    <Card title={t('book_selection')} >
                        <Row>
                            <Col span={24}>
                                <Form.List
                                    {...field}
                                    fieldKey={[field?.fieldKey ?? '', 'bibs_list_items_data']}
                                    name={[field?.name ?? '', 'bibs_list_items_data']}
                                >
                                    {(fields, { add, remove }) => <Row gutter={[8, 8]}>
                                        <Col span={24}>
                                            <Row justify="end">
                                                <Col>
                                                    <AddBibModal
                                                        t={t}
                                                        defaultSelectkeys={propsForm.getFieldValue("bibs_list_items_data")?.map((val) => val?.bib_biblionumber)}
                                                        defaultSelectInfos={propsForm.getFieldValue("bibs_list_items_data")}
                                                        propsForm={propsForm}
                                                        reload={reload}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={24}>
                                            <ProTableOt
                                                reloadButton={false}
                                                manageColumnsButton={false}
                                                showSearch={false}
                                                readonly={true}
                                                actionRef={actionRef}
                                                showMode="infiniteScroll"  // page || infiniteScroll || card || cardPage,
                                                headerTitle={
                                                    <>

                                                    </>
                                                }
                                                columns={columns}
                                                rowKey={'item_itemnumber'}
                                                toolBarRender={() => {
                                                    return [
                                                    ]
                                                }}
                                                manage_columns={false}
                                                request={async (params = {}, sort, filter) => {
                                                    return {
                                                        data: propsForm.getFieldValue('bibs_list_items_data') || [],
                                                        total: (propsForm.getFieldValue('bibs_list_items_data') || []).length
                                                    }
                                                }}
                                                rowSelection={false}
                                                propsPatch={false}
                                                propsDelete={false}
                                                propsPost={false}
                                                propsWidth={2400}
                                                scroll={{
                                                    x: "100%",
                                                }}
                                            />
                                        </Col>
                                    </Row>}
                                </Form.List>
                            </Col>
                        </Row>
                    </Card>
                </Col>

            </Row>
        </>
    );
};
const AddBibModal = ({
    reload = () => { },
    field,
    propsForm,
    propsOpen = null,
    propsLoading = null,
    openButtonText = "詳細資訊",
    defaultSelectkeys = [],
    defaultSelectInfos = [],
    propsSetOpen = () => { },
    propsHandleOk = () => { },
    t,
}) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectRow, setSelectRow] = useState(null)
    const showModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
        reload()
    };

    const handleOk = () => {
        // setLoading(true);
        propsHandleOk(selectRow)
        closeModal();

    };

    return (
        <div>
            <Button
                onClick={showModal}
            >
                {t('add_detail')}
            </Button>

            <Modal
                title={`${openButtonText}`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                // onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                width={1000}
                contentStyle={{
                    padding: 16,
                }}
                okText={'關閉'}
            >
                <Row>
                    <Col span={24}>
                        <BibTable
                            defaultSelectkeys={defaultSelectkeys}
                            defaultSelectInfos={defaultSelectInfos}
                            onSelectChange={(value) => {
                                if (!!propsForm) {
                                    propsForm.setFieldValue("bibs_list_items_data", value)
                                }
                            }}
                        />
                    </Col>
                </Row>
            </Modal>

        </div>
    );
}
const BibTable = ({
    rowKey = "bib_biblionumber",
    keyPrefix = "library.backstage.new_arrivals_list_management",
    showAllColumns = true,
    propsShowColumns,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }//selectInfo
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [tableSearchParams, setTableSearchParams] = useState({
    });
    const [search, setSearch] = useState({
        datecreated_start: dayjs().subtract(1, 'year').format('YYYY-MM-DD'),
        datecreated_end: dayjs().format('YYYY-MM-DD'),
    })
    const columns = [
        {
            title: t(`cover`),
            dataIndex: 'bibitem_isbn',
            key: 'bibitem_isbn',
            width: 140,
            render: (text, record, index) => {
                let fileId = record?.bib_cover_images || []
                let file_id = fileId.map((val) => {
                    return {
                        file_id: val
                    }
                })
                let bookImageData = []
                if (file_id.length > 0) {
                    bookImageData = [
                        ...file_id,
                    ]
                }
                else {
                    bookImageData = [
                        {
                            src: "https://media.taaze.tw/showLargeImageByIsbn.ashx?isbn=" + record?.bibitem_isbn
                        },
                    ]
                }
                return (
                    <Row justify="center">
                        <Col>
                            {
                                bookImageData.filter((e, index) => index === 0).map((value) => {
                                    if (value?.file_id) {
                                        return (
                                            <ImageFileId
                                                key={value?.file_id}
                                                file_id={value?.file_id}
                                                className="h-24 w-16 object-cover"
                                            />
                                        )
                                    }
                                    else {
                                        return (
                                            <img
                                                key={value?.src}
                                                src={"https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=" + record?.bibitem_isbn}
                                                alt={`${record?.bib_title} 封面`}
                                                className="h-24 w-16 object-cover" />
                                        )
                                    }
                                })
                            }
                            <CoverUploadTime
                                record={record}
                                fileId={bookImageData[0]?.file_id}
                            />
                            <div className="mt-1">
                                <BookCoverManager
                                    biblionumber={record?.bib_biblionumber}
                                    title={record?.bib_title}
                                    isbn={record?.bibitem_isbn}
                                    initialFileIds={fileId}
                                    buttonText="圖片"
                                    onChanged={() => actionRef.current?.reloadAndRest()}
                                />
                            </div>

                        </Col>
                    </Row>
                )

            }
        },
        {
            title: t(`title`),
            dataIndex: 'bib_title',
            key: 'bib_title',
            width: 250,
            render: (text, record, index) => {
                return (<ExpandableText
                    text={`${record?.bib_title || ""}${record?.bib_subtitle || ""}`}

                    maxLines={3}>
                </ExpandableText>)

            }
        },
        {
            title: t(`author`),
            dataIndex: 'bib_author',
            key: 'bib_author',
        },
        {
            title: t(`publication_info`),
            dataIndex: 'bibitem_publishercode',
            key: 'bibitem_publishercode',
        },
        {
            title: t(`publication_date`),
            dataIndex: 'bib_copyrightdate',
            key: 'bib_copyrightdate',
        },


    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : [])
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const onFinish = ({ axiosMode, status, values }) => {

    };
    const onBefore = ({ axiosMode, status, values }) => {

    };

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });

    const BibController = useCRUDController({
        apiRoute: "/koha/bib",
        onFinish,
        onBefore
    })

    useEffect(() => {
        checkAll();
    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [tableSearchParams])
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <ProTableOt
                searchParams={{
                    ...tableSearchParams,
                }}
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return [
                        <Col span={24}>
                            <Row gutter={[4, 4]} align={"middle"}>
                                <Col>
                                    <Typography.P>
                                        {/* {t(`${i18nPrefix}.import_bibliography_date`)}: */}
                                    </Typography.P>
                                </Col>
                                <Col>
                                    <Input
                                        type={'date'}
                                        placeholder={t(`time_start`)}
                                        value={search?.datecreated_start ? search?.datecreated_start : ""}
                                        onChange={(e) => {
                                            setSearch((pre) => {
                                                if (dayjs(e.target.value).isBefore(dayjs(pre?.datecreated_end, "YYYY-MM-DD"))) {
                                                    return {
                                                        ...pre,
                                                        datecreated_start: dayjs(e.target.value).format("YYYY-MM-DD"),
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        datecreated_start: pre?.datecreated_end,
                                                        datecreated_end: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <Typography.Title level={4}>
                                        ~
                                    </Typography.Title>
                                </Col>
                                <Col>
                                    <Input
                                        type={'date'}
                                        placeholder={t(`${"time_end"}`)}
                                        value={search?.datecreated_end ? search?.datecreated_end : ""}
                                        onChange={(e) => {
                                            setSearch((pre) => {
                                                if ((dayjs(e.target.value)).isBefore(pre?.datecreated_start)) {
                                                    return {
                                                        ...pre,
                                                        datecreated_start: e.target.value,
                                                        datecreated_end: pre?.datecreated_start,
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        datecreated_end: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                {(search?.datecreated_start || search?.datecreated_end) &&
                                    <Col>
                                        <Button
                                            type={"icon"}
                                            onClick={() => {
                                                setSearch((pre) => {
                                                    return {
                                                        datecreated_start: undefined,
                                                        datecreated_end: undefined
                                                    }
                                                })
                                            }}>
                                            X
                                        </Button>
                                    </Col>
                                }
                            </Row>
                        </Col>
                    ]
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    let newTableSearchParams = { ...tableSearchParams }

                    newParams = {
                        ...newParams,
                        order,
                        size: params.pageSize,
                        cur_page: params.current,
                        // custom_filter_value: params.keyword ?? "",
                        keyword: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        "field": !!params.keyword ? "keyword" : "",
                        ...search
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return BibController.getData(newParams);
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }
                propsPatch={false}
                propsDelete={false}
                propsPost={false}
                propsWidth={2400}
                scroll={{
                    x: "100%",
                }}
            // extraActionRender={(record) => {
            // }}
            />
        </Col>
    </Row>)

}




export default NewArrivalsListForm;
